import { Injector } from '@angular/core';
import { FilterDescriptor } from 'devextreme/data';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonsService } from './commons.service';
import { MessagesService } from './messages.service';
import DataSource from 'devextreme/data/data_source';
import { MachineInfoMainService } from './machine-info.service';
import { BaseApiService } from './base-api.service';

export abstract class MachineSlaveDataServiceBase< 
    TItem = any,
    TKey = any,
    TService extends BaseApiService<TItem> = any
>{
  public dataSource: DataSource;
  protected _currentRow: BehaviorSubject<TItem | undefined> = new BehaviorSubject<TItem | undefined>(undefined);
  public currentRow$: Observable<TItem | undefined> = this._currentRow.asObservable();
  protected _baseUrl: string = environment.baseUrl;
  protected _currentFilter: FilterDescriptor | Array<FilterDescriptor> = [];

  public IsActive: boolean = false;

  protected _miSvc: MachineInfoMainService;
  protected _commonSvc: CommonsService;
  protected _msgSvc: MessagesService;
  protected _entitySvc: TService;

  constructor(injector: Injector, msvc:TService) {
    this._entitySvc = msvc;
    this._miSvc = injector.get(MachineInfoMainService);
    this._commonSvc = injector.get(CommonsService);
    this._msgSvc = injector.get(MessagesService);
    this.Init(); // here must be set URL !!!!
    this.dataSource = this._commonSvc.makeAsyncDataSource<TItem, TKey, TService>(this._entitySvc, this._currentRow, this.filterForCurrentMachine.bind(this));
  }

  protected Init(): void{
    this._miSvc.currentFilter$.subscribe({
      next: (f) => {
        this._currentFilter = f;
        if(this.IsActive){
          this.dataSource?.reload();
        }
      }
    });
  }

  private filterForCurrentMachine(filter: FilterDescriptor | Array<FilterDescriptor>): FilterDescriptor | Array<FilterDescriptor> {
    if (filter != null) {
      return [
        filter,
        "and",
        this._currentFilter
      ];
    } else {
      return this._currentFilter;
    }
  }

  public set CurrentRowId(id: string){
    this._miSvc.CurrentRowId = id;
  }

  public set CurrentRow(r: TItem) {
    this._currentRow.next(r);
  }

  public reloadDataSource() {
    this.dataSource = this._commonSvc.makeAsyncDataSource<TItem, TKey, TService>(this._entitySvc, this._currentRow, this.filterForCurrentMachine.bind(this));
  }
}

